/**
 * Generates an advocate signup redirect URL
 * @param phoneNumber - The business phone number
 * @param referralCode - The referral code (just the number part, e.g., "25")
 * @returns The advocate signup redirect URL
 */
export const generateAdvocateSignupUrl = (
  phoneNumber: string,
  referralCode: string,
): string => {
  const cleanPhone = phoneNumber.replace(/\D/g, "");
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return `${baseUrl}/advocate-signup-redirect?phone=${cleanPhone}&code=${referralCode}`;
};

/**
 * Determines if a navigation item should be marked as active based on the current path
 * @param currentPath - The current location pathname
 * @param basePath - The base path for the navigation section (e.g., "/spiffs")
 * @param itemHref - The href of the navigation item to check (e.g., "/pending-spiffs")
 * @param defaultHref - The default href to match when at the base path (optional)
 * @returns True if the item should be marked as active
 */
export const isNavigationItemActive = (
  currentPath: string,
  basePath: string,
  itemHref: string,
  defaultHref?: string,
): boolean => {
  const atBase = currentPath === basePath || currentPath === `${basePath}/`;
  const suffix = atBase
    ? "/"
    : currentPath.startsWith(basePath)
      ? currentPath.slice(basePath.length) || "/"
      : currentPath;

  if (suffix === "/") {
    return itemHref === "/" || (defaultHref ? itemHref === defaultHref : false);
  }
  // Avoid "/" matching everything
  if (itemHref === "/") return false;
  return suffix.startsWith(itemHref);
};

export const getSafeDownloadUrl = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url, window.location.origin);
    if (
      parsedUrl.protocol !== "http:" &&
      parsedUrl.protocol !== "https:" &&
      parsedUrl.protocol !== "blob:"
    ) {
      return null;
    }

    return parsedUrl.toString();
  } catch {
    return null;
  }
};
